import type React from "react";
import { ReactComponent as Svg } from "./assets/exotic-diamond.svg";
import * as styles from "./Icon.module.scss";

type DiamondProps = React.SVGProps<SVGSVGElement>;

export const Diamond = ({ className, ...props }: DiamondProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
